module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 4
// module chunks = 0